// opervex-frontend/src/pages/Login.js

import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import useOpervex from "../hooks/useOpervex";
import { Row, Button, Container, Col, Form, Spinner, InputGroup } from "react-bootstrap";
import { CgArrowsExchange } from "react-icons/cg";
import ConfirmService from "../components/ConfirmationModal/ConfirmService";

const defaultData = {
  username: "",
  password: "",
  newPassword: "",
  confirmPassword: "",
  tenant: null,
};

const Login = () => {
  const [data, setData] = useState(defaultData);
  const [view, setView] = useState("login");
  const [loadingLogin, setLoadingLogin] = useState(false);
  const [validing, setValiding] = useState(true);

  const { loading, login, user, updatePassword } = useContext(AuthContext);

  const { tenantId } = useParams();
  const OpervexAPI = useOpervex();
  const navigate = useNavigate();

  /**
   * ============================
   * VALIDA TENANT AO CARREGAR
   * ============================
   */
  useEffect(() => {
    const fetchTenant = async () => {
      if (!tenantId) {
        navigate("/StartTenent");
        return;
      }

      const dataTenant = await OpervexAPI.System.Tenant.findId();

      if (dataTenant?.error) {
        await ConfirmService.show("Aviso", dataTenant?.error?.message || "Tenant inválido", true);
        navigate("/StartTenent");
      } else {
        if (dataTenant?.status?.message) {
          await ConfirmService.show("Aviso", dataTenant?.status?.message, true);

          if (!dataTenant?.status?.allowedSystem) navigate("/StartTenent");
        }
        setData((prev) => ({
          ...prev,
          tenant: dataTenant,
        }));
      }

      setValiding(false);
    };

    fetchTenant();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);

  /**
   * ============================
   * REDIRECIONA APÓS LOGIN
   * ============================
   */
  useEffect(() => {
    if (user && !user.initialPassword) {
      navigate(`/${tenantId}`);
    }
  }, [user, tenantId, navigate]);

  if (loading || validing)
    return (
      <div className="vh-100 d-flex justify-content-center align-items-center">
        <Spinner animation="border" />
      </div>
    );

  /**
   * ============================
   * LOGIN
   * ============================
   */
  const handleLogin = async () => {
    setLoadingLogin(true);

    const userData = await login(tenantId, data.username, data.password);

    setLoadingLogin(false);

    if (!userData) {
      alert("Usuário ou senha incorretos!");
    } else if (userData.initialPassword) {
      setView("changePassword");
    }
  };

  /**
   * ============================
   * ALTERAR SENHA
   * ============================
   */
  const handleUpdatePassword = async () => {
    if (!data.newPassword) return alert("Favor informar nova senha");

    if (!data.confirmPassword) return alert("Favor confirmar nova senha");

    if (data.newPassword !== data.confirmPassword) return alert("Senhas devem ser iguais");

    setLoadingLogin(true);

    const userData = await updatePassword(data.newPassword);

    setLoadingLogin(false);

    if (!userData) alert("Erro ao atualizar senha");
    else if (userData?.errors) alert(userData.errors[0].message);
    else navigate(`/${tenantId}`);
  };

  /**
   * ============================
   * HANDLERS
   * ============================
   */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /**
   * ============================
   * TELAS
   * ============================
   */

  const getTenantImage = () => {
    if (data?.tenant?.image?.file && data?.tenant?.image?.length && data?.tenant?.image?.type) {
      return `data:${data.tenant.image.type};base64,${data.tenant.image.file}`;
    }

    return "https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp";
  };

  const htmlLogin = () => (
    <div>
      <h3 className="text-center mb-4">Login</h3>

      <Form.Group className="mb-3">
        <Form.Label>Cliente</Form.Label>
        <InputGroup>
          <Form.Control value={data.tenant?.name || ""} disabled />
          <InputGroup.Text style={{ cursor: "pointer" }} onClick={() => navigate("/StartTenent")}>
            <CgArrowsExchange />
          </InputGroup.Text>
        </InputGroup>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Ambiente</Form.Label>
        <Form.Control value={data.tenant?.system?.name || ""} disabled />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Usuário</Form.Label>
        <Form.Control name="username" value={data.username} onChange={handleChange} />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Senha</Form.Label>
        <Form.Control type="password" name="password" value={data.password} onChange={handleChange} />
      </Form.Group>

      <Button className="w-100" onClick={handleLogin} disabled={loadingLogin}>
        {loadingLogin ? "Carregando..." : "Entrar"}
      </Button>
    </div>
  );

  const htmlChangePassword = () => (
    <div>
      <h3 className="text-center mb-4">Definição de Nova Senha</h3>

      <Form.Group className="mb-3">
        <Form.Label>Nova Senha</Form.Label>
        <Form.Control type="password" name="newPassword" value={data.newPassword} onChange={handleChange} />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Confirmar Nova Senha</Form.Label>
        <Form.Control type="password" name="confirmPassword" value={data.confirmPassword} onChange={handleChange} />
      </Form.Group>

      <Button className="w-100" onClick={handleUpdatePassword} disabled={loadingLogin}>
        {loadingLogin ? "Atualizando..." : "Atualizar"}
      </Button>
    </div>
  );

  return (
    <Container fluid className="vh-100 d-flex flex-column">
      <Row className="flex-grow-1 d-flex justify-content-center align-items-center">
        <Col md={6} className="d-flex align-items-center">
          <img src={getTenantImage()} className="img-fluid" alt="login" />
        </Col>

        <Col md={4}>
          <Form className="p-4 border rounded shadow bg-light">{view === "login" ? htmlLogin() : htmlChangePassword()}</Form>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
